"use client";
import { ContentProvider } from "@/hooks/useContent";
import { ExploreNavbar } from "./_components/ExploreNavbar";
import Sidebar from "./_components/UnifiedSidebar";
import { useAuth } from "@/contexts/AuthContext";
import { ERoles } from "@/data/roles";
import { useTranslations } from "next-intl";
import { GlobalFilterPrompt } from "@/components/filters/GlobalFilterPrompt";
import LogoutButton from "@/components/auth/LogoutButton";

const SecureLayout = ({ children }: { children: React.ReactNode }) => {
  const { user, isInRole } = useAuth();
  const isOrganizationUser = user?.roles?.map((r) => r.roleName).includes(ERoles.OrganizationUser);
  const t = useTranslations();

  return (
    <ContentProvider>
      <div className="h-dvh w-dvw bg-background">
        <div
          className="grid h-dvh w-dvw"
          style={{ gridTemplateColumns: "auto 1fr", gridTemplateRows: "auto 1fr" }}
        >
          {/* Sidebar - spans full height */}
          <div className="row-span-2">
            <Sidebar />
          </div>

          {/* Navbar - spans remaining width, conditional based on role */}
          <div className="relative z-50 col-start-2">
            {isOrganizationUser ? (
              <>
                <ExploreNavbar />
                <GlobalFilterPrompt />
              </>
            ) : (
              <div className="flex h-14 items-center justify-between border-b bg-background px-6">
                <div className="flex items-center gap-3"/>
                <div className="flex items-center justify-between">
                  <LogoutButton variant="icon"/>
                </div>
              </div>
            )}
          </div>
          {/* Content - fills remaining space */}
          <div className="col-start-2 row-start-2 overflow-y-auto">{children}</div>
        </div>
      </div>
    </ContentProvider>
  );
};
export default SecureLayout;
